import { apiClient } from '../Auth/apiClient';
import IResponseBaseTDto from '../Interfaces/IResponseBaseTDto';
import ISearchBaseDto from '../Interfaces/ISearchBaseDto';
import IPageResultDto from '../Interfaces/IPageResultDto';
import { IGenericDonationReportModel, IDonationReportDetailsModel } from '../Interfaces/IReportDtos';

const ReportServiceAPI = {
	GetDonationReportForLocation: async (
		tableData: ISearchBaseDto,
		data: IGenericDonationReportModel
	): Promise<IResponseBaseTDto<IPageResultDto<IDonationReportDetailsModel>>> => {
		const response = await apiClient.post('reportDonations', { ...data, ...tableData });
		return response.data;
	},
	GetDonationReportDaily: async (
		tableData: ISearchBaseDto,
		data: IGenericDonationReportModel
	): Promise<IResponseBaseTDto<IPageResultDto<IDonationReportDetailsModel>>> => {
		const response = await apiClient.post('reportDonationsDaily', { ...data, ...tableData });
		return response.data;
	},
	GetDonationReportMonthly: async (
		tableData: ISearchBaseDto,
		data: IGenericDonationReportModel
	): Promise<IResponseBaseTDto<IPageResultDto<IDonationReportDetailsModel>>> => {
		const response = await apiClient.post('reportDonationsMonthly', { ...data, ...tableData });
		return response.data;
	},
};

export default ReportServiceAPI;
